exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-align[data-v-a4b9d228] {\n  text-align: right;\n}\n.container_nav_page[data-v-a4b9d228] {\n  display: flex;\n  justify-content: center;\n}\n", ""]);

// exports
